import { useSearchParams } from 'react-router-dom';
import { Building2, HardHat, KeyRound } from 'lucide-react';
import Firms from './Firms';
import SubcoCompanies from './SubcoCompanies';
import SubcoManagement from './SubcoManagement';
import { useAuthStore } from '../lib/auth';

const TABS = [['firms', 'Firmalar', Building2], ['subcos', 'Subco Listesi', HardHat], ['subco-logins', 'Subco Giriş Hesapları', KeyRound]];

export default function FirmsHub() {
  const role = useAuthStore((s) => s.user?.role);
  const [sp, setSp] = useSearchParams();
  const tabs = TABS.filter(([k]) => k === 'firms' || ['SUPER_ADMIN', 'FULL_ADMIN'].includes(role));
  const tab = tabs.some(([k]) => k === sp.get('tab')) ? sp.get('tab') : 'firms';
  return (
    <div className="space-y-4">
      {tabs.length > 1 && (
        <div className="inline-flex rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-1 gap-1" data-testid="firms-hub-tabs">
          {tabs.map(([k, l, Icon]) => (
            <button key={k} type="button" onClick={() => setSp({ tab: k })} data-testid={`firms-hub-tab-${k}`}
              className={`h-9 px-3 rounded-lg text-sm font-semibold inline-flex items-center gap-1.5 transition-colors ${tab === k ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800'}`}>
              <Icon className="h-4 w-4" />{l}
            </button>
          ))}
        </div>
      )}
      {tab === 'firms' && <Firms />}
      {tab === 'subcos' && <SubcoCompanies />}
      {tab === 'subco-logins' && <SubcoManagement />}
    </div>
  );
}
